module.exports = __webpack_public_path__ + "static/img/practiceSystem_vip.ec551e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_vip.png
// module id = L1e1
// module chunks = 23